var Form = {};
Form.lastForm = null;
Form.showModal = function ($form, params) {
    if (!($form instanceof jQuery))var $form = $($form);
    if (!$form[0])$form = $(".form-block--FormModal");
    var onS=$form.find("form").attr("data-on-success");
    if(!onS||!onS.match(/Form.closeModal/)){
        $form.find("form").attr("data-on-success", (onS?onS+";":"")+"Form.closeModal()");
    }

    var goal = $form.find("form").data("goal-open");
    if (goal) {
        // YM
        if(typeof(yaCounter28045317)!='undefined'&&yaCounter28045317) yaCounter28045317.reachGoal(goal);
        // GA
        if(typeof(ga)!='undefined') ga('send', 'event', 'Goal', goal);
        console.log("Цель: "+goal);
    }
    $form.modal().open();
    if (params) {
        for (var property in params) {
            if (params.hasOwnProperty(property)) {
                $form.find("[name=" + property + "]").val(params[property]);
            }
        }
    }
    // apply chosen on modal select. it is not done in Form.init as the modal is display:none by default...
    /*setTimeout(function(){
        $form.find("select").each(function(){
            // first, un-chosen:
            $(this).next(".chosen-container").remove();
            $clone=$(this).clone().appendTo($(this).parent());
            var val=$(this).val();
            $(this).remove();
            $clone.val(val);
            $clone.show();
            // now apply chose again
            $clone.chosen({
                disable_search_threshold:10
            });
        });
    },150);*/
}
Form.closeModal = function () {
    var $form = $(".modal");
    $form.modal().close();
}

Form.repeatSubmit = function () {
    if (!Form.lastForm)return;
    if (!Form.check(Form.lastForm))return;
    Form.lastForm.submit();
}
Form.check = function (f) {
    Form.lastForm = f;
    var i;
    var warn = "";

    for (i = 0; i < f.elements.length; i++) {
        var e = f.elements[i];
        //alert(e.name);

        var isFinalWarn = false;

        //alert(e.name);
        var prevent = e.getAttribute("preventSubmit");
        if (prevent) {
            setTimeout("Form.repeatSubmit()", 500);
            return false;
        }

        // clear iFocus:
        var parentIDiv = $(e).parents("div.i");
        if (parentIDiv)parentIDiv.removeClass("iFocus");

        var requiredIfCond = e.getAttribute("requiredIf") || e.getAttribute("validationIf") || e.getAttribute("data-validationIf");
        if (requiredIfCond) var requiredIf = eval(requiredIfCond);
        else var requiredIf = true;

        var required = e.getAttribute("required") || e.getAttribute("validation") || e.getAttribute("data-validation");
        if (required && requiredIf) {
            var errMsg = e.getAttribute("errMsg");
            if ((e.type == "text" || e.type == "password" || e.type == "textarea") && (e.value == "" || $(e).hasClass("placeholder"))) {
                warn = errMsg ? errMsg : "Пожалуйста, введите поле '" + required + "'!";
                if (e.getAttribute("placeholder"))e.value = "";
            }
            else if (e.type == "select-one" && (e.options[e.selectedIndex].value == '' || e.options[e.selectedIndex].value == '%%%NULL%%%')) warn = errMsg ? errMsg : "Пожалуйста, выберите из списка '" + required + "'!";
            else if (e.type == "textarea" && e.value == "") warn = errMsg ? errMsg : "Пожалуйста, введите текст в поле '" + required + "'!";
            else if (e.type == "file" && e.value == "") warn = errMsg ? errMsg : "Пожалуйста, укажите файл в поле '" + required + "'!";
            else if (e.type == "checkbox" && !e.checked) warn = errMsg ? errMsg : "Пожалуйста, поставьте галочку в пункт '" + required + "'!";
            else if (e.type == "radio") {
                for (j = 0; j < f.elements.length; j++) {
                    if (f.elements[j].type == "radio" && f.elements[j].name == e.name && f.elements[j].checked) break;
                }
                if (j == f.elements.length)warn = errMsg ? errMsg : "Пожалуйста, выберите из вариантов '" + required + "'!";
            }

        }
        if (e.type == "file" && e.value != "") {
            var uploadableFormats = e.getAttribute("uploadableFormats");
            if (uploadableFormats) {
                var v = e.value.toLowerCase();
                var fs = uploadableFormats.split(",");
                for (var j = 0; j < fs.length; j++) {
                    if (v.substr(v.length - fs[j].length) == fs[j].toLowerCase()) break;
                }
                if (j == fs.length) warn = errMsg ? errMsg : "Пожалуйста, выберите файл в одном из форматов: " + uploadableFormats;
            }
        }

        // всем телефонам устанавливаем маску:
        if (false && e.name == "phone") {
            e.setAttribute("validationMask", "/^\\+?[78]\\s\\(\\d{3}\\)\\s\\d{3}\\s\\d{2}\\s\\d{2}$/");
            // e.setAttribute("validationMask","/^[\+]{0,1}[78]\d{3}\d{3}\d{2}\d{2}$/");
            // e.setAttribute("validationMask","/^\\s*(((\\+)?7)|8)?[\\s-]*\\d{3}[\\s-]*((\\d{7})|(\\d{3}[\\s-]*\\d{4})|(\\d{3}[\\s-]*\\d{2}[\\s-]*\\d{2}))\\s*$/");
        }

        // всем емейлам устанавливаем маску:
        if (e.name == "email") {
            e.setAttribute("validationMask", "/^([a-z0-9_\-]+\.)*[a-z0-9_\-]+@([a-z0-9][a-z0-9\-]*[a-z0-9]\.)+[a-z]{2,4}$/i");
        }

        // проверяем поле по маске:
        var mask = e.getAttribute("validationMask");
        if (required && requiredIf && mask && (e.type == "text" || e.type == "password" || e.type == "textarea") && !e.value.match(eval(mask))) {
            var msg = e.getAttribute("validationMaskMsg");
            if (msg) {
                warn = msg;
                isFinalWarn = true;
            }
            else warn = "Пожалуйста, введите поле '" + required + "' корректно!";
        }

        if (warn != "") {
            // кастомное сообщение?
            var msg = e.getAttribute("validationMsg");
            if (msg && !isFinalWarn)warn = msg;

            // check there is a parent div.i:
            if (parentIDiv)parentIDiv.addClass("iFocus");
            e.focus();

            //alert(warn);
            Form.showError(e, warn);

            return false;
        }
    }

    //Phone validation
    /*var enteredPhone=f.phone;
     var re1 = /^((\+?7)|8)[-\s]?(\(\d{3}\)|\d{3})[-\s]?\d{3}[-\s]?\d\d[-\s]?\d\d$/;
     var re2 = /^(8?[-\s]?(\(\d\d[-\s]?\d\d\)|(\d\d[-\s]?\d\d)))?[-\s]?\d\d[-\s]?\d\d[-\s]?\d\d$/;
     if (!(re2.test(f.phone.value)) && !(re1.test(f.phone.value))) {
     alert("Пожалуйста, укажите телефон в формате +7 921 999 88 77");
     return false;
     }*/

    // clear placeholders:
    for (i = 0; i < f.elements.length; i++) {
        var e = f.elements[i];
        if ((e.type == "text" || e.type == "password" || e.type == "textarea") && $(e).hasClass("placeholder") && e.getAttribute("placeholder")) {
            e.value = "";
        }
    }

    // ajax or a http request?
    var method = $(f).attr("method");
    if (method == "AJAX") {
        Form.ajaxRequest(f);
        return false;
    }

    return true;
}
Form.onInputFocus = function (e) {
    // document.body.style.backgroundColor="#000";
    var s = $(e.target)[0];
    if (!$(s).hasClass("placeholder"))return;
    $(s).removeClass("placeholder");
    if (s.type == "text") {
        s.value = "";
        if (s.getAttribute("realType") == "password")s.setAttribute("type", "password");
    }
    if (s.type == "textarea")s.value = "";
}
Form.onInputBlur = function (e) {
    var s = $(e.target)[0];
    if (s.type == "select-one" && (s.options[s.selectedIndex].value == '' || s.options[s.selectedIndex].value == '%%%NULL%%%')) {
        $(s).addClass("placeholder");
    }
    else if (s.value.length == 0) {
        Form.setPlaceholder(s);
    }
}
/*Form.onInputChange=function(e){
 var s=Event.target(e);
 CSS.a(s,"clicked");
 }*/
Form.init = function () {
    /*$("form[method='AJAX']").ajaxForm({
     beforeSend: function() {
     },
     uploadProgress: function(event, position, total, percentComplete) {
     },
     success: function() {
     alert("!!! success");
     },
     complete: function(xhr) {
     }
     });*/

    // add AJAX processor:
    /*var $forms = $("form[data-method=AJAX]").each(function () {
     $(this).on("submit", function () {
     Form.ajaxRequest($(this), function () {
     });
     return false;
     });
     });*/

    var forms = document.getElementsByTagName("form");
    for (var j = 0; j < forms.length; j++) {
        var f = forms[j];
        // add placeholders:
        if (f.elements) {
            for (var i = 0; i < f.elements.length; i++) {
                var e = f.elements[i];

                if (!e.getAttribute("placeholder"))continue;

                if (e.type == "text" || e.type == "password" || e.type == "textarea" || e.type == "select-one") {
                    if (!e.value) {
                        // placeholder this element:
                        Form.setPlaceholder(e);
                    }

                    //if(e.getAttribute("isCalendar")) continue;

                    $(e).on("focus", Form.onInputFocus);
                    $(e).on("blur", Form.onInputBlur);
                    //Event.on(e,"change",Form.onInputChange);
                }
            }
        }
    }

    // add chosen:
    var selects = $('select.chosen');
    if (selects[0]) {
        selects.chosen({
            disable_search_threshold: 10
        });
    }

    // add validator to phones:
    var $phoneInputs = $('input[name=phone]');
    $phoneInputs.mask("+7 999 999 99 99", {placeholder: "_"});

    // add calendar on inputs:
    $("input.calendar").each(function () {
        $(this).pickmeup({
            format: 'd.m.Y',
            hide_on_select: true,
            min: $(this).attr("data-min"),
            max: $(this).attr("data-max"),
            default_date: new Date(),
            trigger_event: "click touchstart focus",
            locale: { // Object, that contains localized days of week names and months
                days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье"],
                daysShort: ["Вск", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вск"],
                daysMin: ["Вск", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вск"],
                months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
                monthsShort: ["Янв", "Февр", "Март", "Апр", "Май", "Июнь", "Июль", "Авг", "Сент", "Ост", "Ноябрь", "Дек"]
            },
            before_show: function () {
                var date = $(this).text();
                if (date) {
                    date = date.split('.');
                    var date = new Date(date[2], date[1] - 1, date[0]);
                    $(this).pickmeup('set_date', date, true);
                }
            },
            change: function (formated) {
                $(this).html(formated);
                var callBack = $(this).attr('data-changeCallBack');
                if (callBack) {
                    eval(callBack);
                }
            }
        });
    });
}
Form.setPlaceholder = function (s) {
    if (s.getAttribute("placeholder")) {
        var supportsPlaceholder = !!('placeholder' in document.createElement('input'));
        if (supportsPlaceholder) {
            s.placeholder = s.getAttribute("placeholder");
        }
        else {
            if (s.type != "select-one")s.value = s.getAttribute("placeholder");
            if (s.getAttribute("type") == "password") {
                s.setAttribute("realType", "password");
                s.setAttribute("type", "text");
            }
            $(s).addClass("placeholder");
        }
    }
}
$(document).ready(Form.init);

Form.ajaxUpdate = function (parentSelect, clearChilds) {

    if (clearChilds) {
        var childs = clearChilds.split(',');
        for (i = 0; i < childs.length; i++) {
            var el = get(childs[i]);
            el.innerHTML = '';
            var placeholder = el.getAttribute("placeholder");
            if (placeholder) {
                el.innerHTML = "<option>" + placeholder + "</option>";
            }
        }
    }

    var childId = parentSelect.getAttribute("child");

    if (!childId)return;

    Form.clearAllChildren(childId);
    var parentForm = HTML.parent(parentSelect, "form", null, true);
    var childElement = get(childId); 							//parentForm[childId];
    //console.log("childElement for "+parentSelect.id+":"+childElement);

    // remove iFocus/edit from all inputs:
    var divs = parentForm.getElementsByTagName("div");
    for (var i = 0; i < divs.length; i++) {
        CSS.r(divs[i], "iFocus");
    }

    $(childElement).addClass("ajaxLoading");

    Form.ajaxRequest(childId, function (r) {

        CSS.r(childElement, "ajaxLoading");

        var html = r.html;
        // ADD new child if have any:
        if (!html)return;
        childElement.innerHTML = html;
        PublicPage.applyCufon();
        childElement.focus();
        var parentIDiv = HTML.parent(childElement, "div", "i", true);
        if (parentIDiv)CSS.a(parentIDiv, "iFocus");
    });
    var interval = setInterval(function () {
        var childrens = childElement.getElementsByTagName('*');
        var count = childrens.length;
        if (count > 0) {
            for (i = 0; i < count; i++) {
                var chld = childrens[i];
                var atr = chld.getAttribute('child');
                if (atr && chld.getAttribute('move')) {
                    Form.ajaxUpdate(chld, false);
                    break;
                }
            }
            clearInterval(interval);
        }
    }, 500);
}

Form.clearAllChildren = function (firstChild) {
    var currentElement = get(firstChild);
    var child = currentElement.getAttribute("child");
    //alert(currentElement.id+" "+child);
    if (child) {
        Form.clearAllChildren(child);
    }
    currentElement.innerHTML = "";

}

Form.ajaxRequest = function (form, callback) {
    if (!(form instanceof jQuery))var form = $(form)[0];
    else var form = form[0];
    var str = new Array();

    // collect form data:
    var formData = new FormData(form);

    $("html").addClass("busy");
    $(form).addClass("busy");
    $(form).find(':input').prop("disabled", true);

    $.ajax({
        type: "POST",
        url: $(form).attr("action"),
        processData: false,
        data: formData,
        contentType: false,
        //enctype: 'multipart/form-data',
        success: function (x) {
            $("html").removeClass("busy");
            $(form).find(':input').prop("disabled", false);
            $(form).removeClass("busy");

            if (!x || typeof x == 'undefined') {
                Form.showError($(form), "Ошибка. Пожалуйста, повторите запрос позже.");
                /*var resp={};
                 resp.err='<div class="errors"><div class="err">Ошибка. Пожалуйста, повторите запрос позже.</div></div>';*/
            }
            else {
                var r = eval("(" + x + ")");

                if (callback)callback(r);

                if (r.html && form.getAttribute("data-html")) {
                    var $htmlReceiver = $("#" + form.getAttribute("data-html"));
                    if ($htmlReceiver) {
                        $htmlReceiver.html(r.html);
                    }
                }

                if (r.msg)Form.showMsg(r.msg);

                var onSuccess = $(form).attr("data-on-success");
                if (onSuccess) {
                    eval(onSuccess);
                }

                var goal = $(form).attr("data-goal");
                if (goal) {
                    // YM
                    if(typeof(yaCounter28045317)!='undefined'&&yaCounter28045317) {
                        yaCounter28045317.reachGoal(goal);
                        console.log("Цель yaCounter28045317: "+goal);
                    }
                    // GA
                    if(typeof(ga)!='undefined') ga('send', 'event', 'Goal', goal);
                    // console.log("Цель: "+goal);
                }

                if ($(form).attr("data-hide-on-submit")) {
                    $(form).animate({opacity: 0}, function () {
                        $(this).hide();
                    });
                }

                // LeadTracek integration:
                if(typeof LeadTracker!='undefined' && typeof LeadTracker.uId!='undefined'){
                    LeadTracker.submit(form);
                }

            }

        }
    });
}
Form.showError = function (el, warn) {
    return alert(warn);

    var offset = 20;
    var parent = $(el).parents("div.i");
    if (!parent) {
        parent = $(el);
        offset = 6;
    }
    var err = $("formErrMsg")[0];
    ///var thinBody=STR.haveClass(document.body, 'w1024');
    if (err)document.body.removeChild(err);
    var err = document.createElement("DIV");
    d.body.appendChild(err);
    err.innerHTML = warn;
    err.id = "formErrMsg";
    var tri = document.createElement("DIV");
    err.appendChild(tri);
    tri.className = "triangle";
    //alert();
    err.style.left = (parent.offset().left - 260) + "px";

    err.style.top = (parent.offset().top - Math.round(err.offsetHeight / 2) + offset) + "px";
    tri.style.top = (Math.round(err.offsetHeight / 2) - Math.round(tri.offsetHeight / 2)) + "px";
    Event.on(err, "click", function () {
        Form.closeError();
    });

}
Form.closeError = function () {
    var err = get("formErrMsg");
    if (err)document.body.removeChild(err);
}
Form.showMsg = function (msg) {
    return alert(msg);
};

window.Form = Form;


// WEBPACK FOOTER //
// ../htdocs/js/Form.js